import React from "react";

/**
 * Standardized tab button component for consistent sizing
 */
export default function TabButton({
  active = false,
  onClick,
  children,
  className = "",
}) {
  const baseClasses =
    "px-4 sm:px-8 py-3 rounded-lg font-medium transition-colors w-full sm:min-w-[220px] text-center";

  // The inactive label is deliberately NOT one of the named text roles (see
  // clause 2 of docs/UI_STANDARD.md). Those are measured against the page or
  // a card ; this one sits on the pill's own fill, so it takes the -800 /
  // -200 BADGE treatment : 10.35:1 light and 6.90:1 dark against that fill.
  // Shared with the other two BADGES on bg-gray-100 dark:bg-gray-700 (the
  // Public tag in ApiDocs.jsx and the record-type tag in CAAChecker.jsx) -
  // change it only together with those, or they drift apart. The fill alone
  // does NOT decide the treatment : the inline <code> in ApiDocs.jsx uses the
  // same fill and correctly keeps its sentence's text-body, because it is
  // prose emphasis rather than a badge.
  const stateClasses = active
    ? "bg-blue-600 text-white"
    : "bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 hover:bg-gray-200 dark:hover:bg-gray-600";

  return (
    <button
      type="button"
      onClick={onClick}
      className={`${baseClasses} ${stateClasses} ${className}`}
    >
      {children}
    </button>
  );
}
